module.exports = __webpack_public_path__ + "static/media/default-author.a6546ccb.png";